import { PurchasingRepository } from '@Purchasing/Data/Repository/PurchasingRepository'
import {
    AuditEvent,
    PurchasingStage,
    SourceContext,
} from '@Purchasing/Domain/Model/PurchaseProcess'

export interface GetPurchaseProcessAudit {
    execute(id: string): Promise<AuditEvent[]>
    getSource(): string
}

export class GetPurchaseProcessAuditUseCase implements GetPurchaseProcessAudit {
    constructor(private repository: PurchasingRepository) {}
    async execute(id: string): Promise<AuditEvent[]> {
        return this.repository.getProcessAudit(id)
    }
    getSource(): string {
        return this.repository.dataSource.getSource()
    }
}

export interface GetPurchasingStages {
    execute(): Promise<PurchasingStage[]>
    getSource(): string
}

export class GetPurchasingStagesUseCase implements GetPurchasingStages {
    constructor(private repository: PurchasingRepository) {}
    async execute(): Promise<PurchasingStage[]> {
        return this.repository.getStages()
    }
    getSource(): string {
        return this.repository.dataSource.getSource()
    }
}

export interface GetSourceContext {
    execute(code?: string, externalId?: string): Promise<SourceContext>
    getSource(): string
}

export class GetSourceContextUseCase implements GetSourceContext {
    constructor(private repository: PurchasingRepository) {}
    async execute(code?: string, externalId?: string): Promise<SourceContext> {
        return this.repository.getSourceContext(code, externalId)
    }
    getSource(): string {
        return this.repository.dataSource.getSource()
    }
}
